<template>
    <div class="flex gap-4 items-center">
        <audio
            class="sr-only"
            controls
            ref="audioPlayer"
            @ended="isPlaying = false"
        >
            <source :src="url" type="audio/mp3" />
        </audio>

        <button
            :class="'flex gap-2.5 items-center text-left ' + order"
            type="button"
            :aria-label="isPlaying ? 'Pause audio' : 'Play audio'"
            @click="toggleAudio"
        >
            <div 
                class="w-12 h-12 min-w-12 min-h-12 flex justify-center items-center rounded-full text-white"
                :class="isPlaying ? 'bg-blue-11 animate-[pulse_1s_ease-in-out_infinite]' : 'bg-blue-11'"
            >
                <Icon
                    name="audio"
                    dir="/icons/icon-selector/"
                    class="w-5 h-8"
                />
            </div>

            <span
                v-if="transcript != null"
                class="text-lg font-semibold"
                :class="isPlaying ? 'underline' : ''"
            >
                <span v-html="transcript"></span>
            </span>
        </button>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import Icon from '../pieces/Icon.vue';

const props = defineProps({
    url: String,
    transcript: String,
    order: String
});

const audioPlayer = ref(null);
const isPlaying = ref(false);

const toggleAudio = () => {
    if (audioPlayer.value.paused) {
        audioPlayer.value.play();
        isPlaying.value = true;
    } else {
        audioPlayer.value.pause();
        isPlaying.value = false;
    }
};
</script> 
